export enum AccountSettingType {
  DEFAULT = 'DEFAULT',
  CONTROL = 'CONTROL',
  BANK_ACCOUNT = 'BANK_ACCOUNT',
  CASH_ACCOUNT = 'CASH_ACCOUNT',
  PROJECT = 'PROJECT',
  RESALE = 'RESALE',
}
